/* Spring campaign presentation. Shopify remains the source of checkout prices. */
(function () {
  'use strict';
  function pairOffer(first, second) {
    if (!first || !second || !first.available || !second.available) return null;
    if (first.compare_at_price > first.price || second.compare_at_price > second.price) return null;
    const saving = Math.round(Math.min(Number(first.price), Number(second.price)) * 0.3);
    return { saving: saving, total: Number(first.price) + Number(second.price) - saving };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { pairOffer: pairOffer };
  if (typeof document === 'undefined') return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function money(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency', currency: (window.theme && window.theme.currencyCode) || 'AUD'
    }).format(value / 100);
  }
  function updatePair(bundle) {
    if (!bundle) return;
    const output = bundle.querySelector('[data-spring-pair]');
    if (!output) return;
    try {
      const mainVariants = JSON.parse(bundle.querySelector('[data-spring-main-variants]').textContent);
      const extraVariants = JSON.parse(bundle.querySelector('[data-bst-bundle-variants]').textContent);
      const selected = Array.from(bundle.querySelectorAll('[data-bst-bundle-option]')).map(s => s.value);
      const first = mainVariants.find(v => String(v.id) === bundle.dataset.mainVariantId);
      const second = extraVariants.find(v => v.options.every((value, index) => value === selected[index]));
      const offer = pairOffer(first, second);
      output.hidden = !offer;
      if (offer) output.textContent = output.dataset.mode === 'preview' ? 'Spring offer preview: ' + money(offer.total) + ' together — save ' + money(offer.saving) + '. Discount not active yet; the button shows today’s price.' : 'Spring savings are applied automatically in your bag. The button shows prices before discounts.';
    } catch (_) { output.hidden = true; }
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-spring-add] select[name="id"]')) {
      const card = event.target.closest('.bst-spring-card');
      const selected = event.target.selectedOptions[0];
      const image = card && card.querySelector('.bst-spring-card__image img');
      if (image && selected && selected.dataset.image) { image.removeAttribute('srcset'); image.src = selected.dataset.image; }
    }
    const bundle = event.target.closest('[data-bst-bundle]');
    if (bundle) window.requestAnimationFrame(() => updatePair(bundle));
  });
  document.addEventListener('theme:variant:change', function () {
    window.requestAnimationFrame(() => document.querySelectorAll('[data-bst-bundle]').forEach(updatePair));
  });
  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('[data-spring-add]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-spring-status]');
    form.dataset.busy = 'true'; button.disabled = true; button.setAttribute('aria-busy', 'true');
    status.textContent = 'Adding to your bag…';
    let added = false;
    try {
      const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'}, body: JSON.stringify({items:[{id:Number(form.elements.id.value),quantity:1}]})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'That option could not be added. Please choose another.');
      added = true;
      status.textContent = 'Added to your bag. Choose another piece or checkout.';
      const cartResponse = await fetch(root + 'cart.js');
      if (!cartResponse.ok) throw new Error('Your item was added. Open your bag to see it.');
      const cart = await cartResponse.json();
      document.dispatchEvent(new CustomEvent('theme:cart:change', {detail:{cart:cart},bubbles:true}));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles:true}));
      const drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (drawer) drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {bubbles:false}));
    } catch (error) {
      status.textContent = added ? 'Your item was added. Open your bag to see it; do not add it again.' : (error instanceof TypeError ? 'Connection interrupted. Please check your bag before trying again.' : error.message);
    } finally {
      const link = document.createElement('a');link.href = root + 'cart';link.textContent = ' View bag →';status.appendChild(link);
      form.dataset.busy = 'false';button.disabled = false;button.removeAttribute('aria-busy');
    }
  });
})();
